import { render, staticRenderFns } from "./Apply.vue?vue&type=template&id=0a87f406&scoped=true"
import script from "./Apply.vue?vue&type=script&lang=js"
export * from "./Apply.vue?vue&type=script&lang=js"
import style0 from "./Apply.vue?vue&type=style&index=0&id=0a87f406&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a87f406",
  null
  
)

export default component.exports